"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  orgnizationinfos: {
    index: 'index',
    orgId: 'org Id',
    orgCode: 'org Code',
    orgName: 'org Name',
    pntOrgIdName: 'pnt Org Id Name',
    pntOrgId: 'pnt Org Id',
    companyName: 'company Name',
    company: 'company',
    orgType: 'orgType',
    cmt: 'status',
    cosConId: 'cos Con Id',
    ordprefix: 'ordprefix',
    fleet: 'fleet',
    fleet2: 'fleet2',
    userange: 'userange',
    universal: 'universal',
    shoreBase: 'shoreBase',
    boatPipe: 'boatPipe',
    telephone: 'telephone',
    fax: 'fax',
    zipCode: 'zipCode',
    orgAddr: 'orgAddr',
    orgIcon: 'orgIcon',
    orgename: 'orgename',
    orgeaddr: 'orgeaddr',
    owner: 'owner',
    isexternal: 'isexternal',
    createDate: 'create Date',
    remark: 'remark',
    add: 'add',
    del: 'del',
    edit: 'edit',
    print: 'print',
    table: 'table',
    stamp: 'stamp',
    crewManagement: 'crew Management',
    crewPoolMaintenance: 'crew Pool Maintenance',
    submitted: 'submitted',
    unSubmitted: 'un Submitted',
    hint: 'hint',
    confirm: 'confirm',
    cancel: 'cancel',
    delSuc: 'del Suc',
    delFail: 'del Fail',
    delCancel: 'del Cancel',
    selectOneData: 'select One Data',
    crewPoolData: 'crew Pool Data',
    save: 'save',
    submit: 'submit',
    yes: 'yes',
    no: 'no',
    goBack: 'goBack',
    basicInfo: 'basic Info',
    operateInfo: 'operate Info',
    createInfo: 'create Info',
    modifyInfo: 'modify Info',
    submitInfo: 'submit Info',
    message1: 'Please select the row to delete',
    message2: 'This operation will permanently delete the piece of data',
    message3: 'Your changes may not be saved',
    message4: 'Please fill in the department code',
    message5: 'Please fill in the department name',
    message6: 'Please fill in the correct mobile number',
    message7: 'Successfully saved',
    message8: 'Failed to save',
    message9: 'abnormal',
    message10: 'close the window',
    message11: 'Please fill in the correct postal code',
    message12: 'Please fill in the department category',
    message13: 'Submitted data cannot be deleted'
  }
};